import { useLayoutEffect } from 'react';

let activeReportingHostCount = 0;

/**
 * DevExpress overlays are mounted under document.body rather than the React
 * host. Keep a scoped marker alive for as long as any reporting host exists so
 * the shared adapter can theme those popups without changing ordinary app UI.
 */
export function useReportingVendorChromeScope() {
    useLayoutEffect(() => {
        const body = typeof document === 'undefined' ? null : document.body;
        activeReportingHostCount += 1;
        body?.classList.add('reporting-vendor-overlays');

        return () => {
            activeReportingHostCount = Math.max(0, activeReportingHostCount - 1);
            if (activeReportingHostCount === 0) {
                body?.classList.remove('reporting-vendor-overlays');
            }
        };
    }, []);
}
